import React from 'react';
import ru_RU from 'antd-core/es/date-picker/locale/ru_RU';
import en_US from 'antd-core/es/date-picker/locale/en_US';
import { useLanguage } from '../locale/Language.js';

const useDatePickerLocale = (locale) => {
    const lang = useLanguage('useDatePickerLocale');
    return React.useMemo(() => {
        const defaultLocale = locale !== null && locale !== void 0 ? locale : { ru: ru_RU, en: en_US }[lang];
        return Object.assign(Object.assign({}, defaultLocale), { lang: Object.assign({ monthFormat: 'MMMM' }, defaultLocale.lang) });
    }, [lang, locale]);
};

export { useDatePickerLocale };
//# sourceMappingURL=useDatePickerLocale.js.map
